import WeatherApp from "./components/WeatherApp"
import "./App"

const App = () => (
  <WeatherApp/>
)

export default App
